import { requestBuilder } from '../../http/RequestBuilder';
import type { GuideMessagingDto } from '../types/GuideMessaging';

const useGetGuideMessaging = requestBuilder.query<GuideMessagingDto>({
    endpoint: () => `/api/guidance/messaging`,
    queryKey: () => `getMessagingAccount`,
});

export default useGetGuideMessaging;
